import React, { useContext, useState } from 'react';
import Icons from '../Icons';
import { Context } from "../contexts/AppContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { postData, putData } from '../../lib/utils';
import { useParams } from 'react-router-dom';

function UploadMusicBg(props) {
  const [audioFile, setAudioFile] = useState(null);
 
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const { galleryId } = useParams();
  const { currentFolderData, currentFolderName, currentGalleryData } = appState;
    const [musicUrl, setmusicUrl] = useState(null);

  const deleteMusicBg=async()=>{
  
  
         try { 
                  const filePath =appState?.currentGalleryData?.backgroundMedia?.musicUrl;
                        const _json = await postData("products/delete-file", {
                         fileName:filePath
                        })
                        if (_json) {
                         console.log("Delete Gallery");
                         
      const json = await putData(`galleries/gallery/${galleryId}/background`, {
        musicUrl: null
      });
  
      if (json) {
                  // Update both appState and local state for instant preview
                  setAppState((prevState) => ({
                    ...prevState,
                    currentGalleryData: {
                      ...prevState.currentGalleryData,
                      backgroundMedia: {
                        ...prevState.currentGalleryData.backgroundMedia,
                        musicUrl: json.backgroundMedia.musicUrl
                      }
                    }
                  }));
                  setmusicUrl(json.backgroundMedia.musicUrl);
                 props.deleteFile()
  
                }
                        }
                     } catch (error) {
                       console.error("Error deleting file:", error);
                     }
  }

  // Handle file input
const handleFileChange = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  // ✅ Convert file size to MB
  const fileSizeMB = file.size / (1024 * 1024);

  // ✅ Available credits in MB (from admin details)
  const availableCreditsMB = appState?.adminDetails?.credits || 0;

  // ✅ Check if file size exceeds available credits
  if (fileSizeMB > availableCreditsMB) {
    const fileSizeDisplay =
      fileSizeMB >= 1024
        ? `${(fileSizeMB / 1024).toFixed(2)} GB`
        : `${fileSizeMB.toFixed(2)} MB`;

    const creditsDisplay =
      availableCreditsMB >= 1024
        ? `${(availableCreditsMB / 1024).toFixed(2)} GB`
        : `${availableCreditsMB.toFixed(2)} MB`;

    alert(
      `⚠️ Not enough credits!\n\nFile size: ${fileSizeDisplay}\nAvailable credits: ${creditsDisplay}`
    );
    return;
  }

  // ✅ Sanitize file name (replace spaces with "_")
  const sanitizedFileName = file.name.replace(/\s+/g, "_");

  // ✅ Create a new File object with sanitized name
  const sanitizedFile = new File([file], sanitizedFileName, { type: file.type });

  setAudioFile(sanitizedFile);
  await handleUpload(sanitizedFile);
};


  // Get Presigned URL from Backend
  const getPresignedUrl = async (file) => {
    const folderPath = `${currentFolderData.adminId}/${currentFolderData.id}/${currentGalleryData._id}`;
  
    const presignedApi = `${process.env.REACT_APP_API_PATH}products/generate-presigned-url?folderPath=${folderPath}&fileName=${file.name}&fileType=${file.type}`;
    console.log('Presigned API:', presignedApi);

    const response = await fetch(presignedApi, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        file_name: `${folderPath}/${file.name}`,
      }),
    });

    return response.json();
  };

  // Upload to S3
  const handleUpload = async (file) => {
    try {
      props.handleUpload(file);

      const data = await getPresignedUrl(file);
      const { upload_url } = JSON.parse(data.body);
      console.log("Upload URL:", upload_url);

      const xhr = new XMLHttpRequest();
      xhr.open("PUT", upload_url, true);

      xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
          props.audioOnPrg?.();
        }
      };

      xhr.onload = function () {
        if (xhr.status === 200) {
          console.log("Audio uploaded successfully");
          props.audioUploadedDone(file);
        } else {
          console.error("Upload failed with status:", xhr.status);
          props.uploadFailed(file);
        }
      };

      xhr.onerror = function () {
        console.log("Network error during upload");
        alert("Network error during upload");
      };

      // ✅ Upload sanitized file
      xhr.send(file);
    } catch (error) {
      console.error("Error uploading audio:", error);
    }
  };

  return (
    <div className='flex '>
      <input
        type="file"
        accept="audio/*"
        onChange={handleFileChange}
        id="audioInput"
        style={{ display: "none" }}
      />
      <button
        type="button"
        onClick={() => {
          console.log("Upload button clicked!");
          document.getElementById("audioInput").click();
        }}
        className="btn-yellow flex gap-4 justify-center"
      >
        <Icons.Uploads /> Upload Track
      </button>    
        <FontAwesomeIcon  
          icon={faTrash} 
          onClick={deleteMusicBg}
          style={{ color: "white", backgroundColor:'#854d0e', border:'1px solid', padding:'12px' ,cursor:"pointer" }} 
          className="ml-2 flex-shrink-0"
        />
    </div>
  );
}

export default UploadMusicBg;
